export default __webpack_public_path__ + "static/fb-editorial-men-800128529291fa305ae347c80ee845e2.jpg";